import {DateIntervalType} from "./interval"
import DatetimeUtils from "../datetime-utils"
import Moment from "moment/moment"
import formatDate from "../../format/date"
import {toRoman} from "../to-roman"
import GroupBy from "../../manager/group-by/group-by-model"

// const debug = "getIntervalLabel"
const debug = false

export function getIntervalLabel(value:string|Moment, groupBy?: GroupBy): string {

    const interval = groupBy?.params.interval || DateIntervalType.DAILY
    const showFullIntervalLabel = groupBy?.showFullIntervalLabel || false

    // normalize value to Moment
    let momentValue       : Moment
    if (Moment.isMoment(value)) {
        momentValue = value
    } else {
        // momentValue = DatetimeUtils.datetimeToMoment(value) // this is wrong if start of month it trys add time zone so prev motnh or even prev year
        momentValue = DatetimeUtils.dateToMoment(value) 
    }

    if (!momentValue) {
        return ''
    }

    switch (interval) {
        case DateIntervalType.YEARLY:
            return momentValue.format('YYYY')

        case DateIntervalType.QUARTERLY:
            return toRoman(momentValue.quarter()) + " " + momentValue.year()
            // return momentValue.year()+ "-" + toRoman(momentValue.quarter())

        case DateIntervalType.MONTHLY:
            return momentValue.format('MMM YYYY')

        case DateIntervalType.BIWEEKLY:
            if (showFullIntervalLabel) {
                let label
                const beWeekStartLabel  = momentValue.format("MMM Do")
                const beWeekEndDate     = momentValue.clone().add(1, 'week').endOf("isoWeek")
                const beWeekEndLabel    = momentValue.isSame(moment(), 'year') ? beWeekEndDate.format("MMM Do") : beWeekEndDate.format("MMM Do, YYYY")
                label = '{0} - {1}'.f(beWeekStartLabel, beWeekEndLabel)
                return label
            } else {
                return formatDate(momentValue)
            }

        case DateIntervalType.WEEKLY:
            if (showFullIntervalLabel) {
                let label
                const referenceDate     = momentValue.clone().startOf("isoWeek")
                const weekStartLabel    = referenceDate.format("MMM Do")
                const weekEndDate       = referenceDate.clone().endOf("isoWeek")
                const weekEndLabel      = referenceDate.isSame(moment(), 'year') ? weekEndDate.format("MMM Do") : weekEndDate.format("MMM Do, YYYY")
                label = '{0} - {1}'.f(weekStartLabel, weekEndLabel)
                return label
            } else {
                return formatDate(momentValue)
            }

        case DateIntervalType.DAILY:
        default:
            return formatDate(momentValue)
    }



}